import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function CheckoutCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-24">
      <div className="max-w-xl w-full card-cream p-10" data-testid="checkout-cancel-panel">
        <div className="flex items-center gap-3 mb-8">
          <XCircle size={18} className="text-[#e88a51]" />
          <span className="tick">Checkout cancelled</span>
        </div>
        <h1 className="font-serif-display text-4xl text-[#171717] mb-6 leading-tight">
          No charges were captured.
        </h1>
        <p className="font-mono-tech text-[13px] text-[#404040] leading-relaxed mb-8">
          You closed the Stripe checkout before completing payment. The briefing remains
          available whenever you're ready to unlock the advanced audits.
        </p>
        <Link to="/#pricing" className="btn-primary" data-testid="checkout-cancel-return">Return to ladder</Link>
      </div>
    </div>
  );
}
